/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
export const state = {
    currentUser: localStorage.getItem('currentUser') || false,
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('currentUser', newValue)
    },
}

export const getters = {
    loggedIn(state) {
        return !!state.currentUser;
    },
    currentUser(state) {
        return state.currentUser;
    },
}
export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        dispatch('validate')
    },
    // Logs in the current user.
    async getUrl({ commit, dispatch, getters }, _url = {}) {
        let theUrl = window.APP_DATA.apiUrl + _url;
        let currentUser = localStorage.getItem('currentUser') || false;
        currentUser = currentUser ? JSON.parse(currentUser) : false;
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open( "GET", theUrl, false );
        xmlHttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xmlHttp.setRequestHeader('x-access-token', currentUser.access_token);xmlHttp.setRequestHeader('odoo-token', currentUser.token);
        xmlHttp.setRequestHeader('uid', currentUser.id);xmlHttp.setRequestHeader('pid', currentUser.pos_id);
        
        
        
        xmlHttp.send();
        if(xmlHttp.status == 400){
            let error = JSON.parse(xmlHttp.responseText);
            let error_text = [];
            if(typeof error.detail != 'undefined') error_text.push('Detail: ' + error.detail.join(' '));
            if(error_text.length < 1) error_text.push('Cannot connect backend');
            throw error_text.join('. ');
        }
        if(xmlHttp.status == 401){
            let error = JSON.parse(xmlHttp.responseText);
            if(typeof error.messages != 'undefined' && typeof error.messages[0] != 'undefined'){
                for(const err_item of error.messages){
                    if(error.messages[0].message == 'Token is invalid or expired'){
                        localStorage.removeItem('currentUser');
                    }
                }
                throw (error.messages[0].message);
            }
            if(typeof error.detail == 'string') throw (error.detail);
            throw ('Cannot connect backend');
        }
        return JSON.parse(xmlHttp.responseText);
    },
    async postUrl({ commit, dispatch, getters }, obj = {}) {
        let theUrl = window.APP_DATA.apiUrl + obj.url;
        let currentUser = localStorage.getItem('currentUser') || false;
        currentUser = currentUser ? JSON.parse(currentUser) : false;
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open( "POST", theUrl, false );
        xmlHttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xmlHttp.setRequestHeader('x-access-token', currentUser.access_token);xmlHttp.setRequestHeader('odoo-token', currentUser.token);
        xmlHttp.setRequestHeader('uid', currentUser.id);xmlHttp.setRequestHeader('pid', currentUser.pos_id);
        
        xmlHttp.send(JSON.stringify(obj.data));
        if(xmlHttp.status == 400){
            let error = JSON.parse(xmlHttp.responseText);
            let error_text = [];
            if(typeof error.variable != 'undefined') error_text.push('Variable: ' + error.variable.join(' '));
            if(typeof error.detail != 'undefined') error_text.push('Detail: ' + error.detail.join(' '));
            if(error_text.length < 1) error_text.push('Cannot connect backend');
            throw (error_text.join('. '));
        }
        if(xmlHttp.status == 401){
            let error = JSON.parse(xmlHttp.responseText);
            if(typeof error.messages != 'undefined' && typeof error.messages[0] != 'undefined'){
                for(const err_item of error.messages){
                    if(error.messages[0].message == 'Token is invalid or expired'){
                        localStorage.removeItem('currentUser');
                    }
                }
                throw (error.messages[0].message);
            }
            if(typeof error.detail == 'string') throw (error.detail);
            throw ('Cannot connect backend');
        }
        return JSON.parse(xmlHttp.responseText);
    },

    // Logs in the current user.
    async logIn({ commit, dispatch, getters }, _data = {}) {
        if (getters.loggedIn) return dispatch('validate');
        let theUrl = window.APP_DATA.apiUrl + 'login';
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open( "POST", theUrl, false );
        xmlHttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xmlHttp.send(JSON.stringify(_data));
        if(xmlHttp.status == 400){
            throw 'Không thể kết nối server';
        }
        let res = JSON.parse(xmlHttp.responseText);
        if(typeof res.error == 'undefined' || typeof res.data == 'undefined' || typeof res.message == 'undefined'){
            throw 'Không thể kết nối server';
        }
        if(res.error){
            throw res.message;
        }

        let user = res.data;
        commit('SET_CURRENT_USER', user);
        return user;
    },
    ssoCheck({ commit }) {
        try {
            let theUrl = window.APP_DATA.apiUrl + 'sso-check';
            var xmlHttp = new XMLHttpRequest();
            xmlHttp.open('GET', theUrl, false);
            xmlHttp.withCredentials = true;
            xmlHttp.send();
            // 5xx hoặc unreachable → backend lỗi, không phải "chưa login ONE"
            if (xmlHttp.status === 0 || xmlHttp.status >= 500) return 'server_error';
            if (xmlHttp.status !== 200) return 'no_session';
            let res;
            try { res = JSON.parse(xmlHttp.responseText); } catch (e) { return 'no_session'; }
            if (!res || res.error || !res.data) return 'no_session';
            commit('SET_CURRENT_USER', res.data);
            return res.data;
        } catch (e) {
            return 'server_error';
        }
    },
    async ssoLogin({ commit }, sso_token) {
        if (!sso_token) return null;
        let theUrl = window.APP_DATA.apiUrl + 'sso';
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open('POST', theUrl, false);
        xmlHttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        xmlHttp.send(JSON.stringify({ sso_token }));
        if (xmlHttp.status !== 200) return null;
        let res;
        try { res = JSON.parse(xmlHttp.responseText); } catch (e) { return null; }
        if (!res || res.error || !res.data) return null;
        commit('SET_CURRENT_USER', res.data);
        return res.data;
    },
    logOut({ commit }) {
        commit('SET_CURRENT_USER', null);
        localStorage.removeItem('currentUser');
        localStorage.removeItem('sessionID');
        localStorage.removeItem('posTab');
        
    },
    validate({ commit, state }) {
        if (!state.currentUser) return Promise.resolve(null)
        let user = localStorage.getItem('currentUser') || false;
        try {
            user = user ? JSON.parse(user) : false;
        } catch (error) {
            console.log(error);
        }
        if(user){
            user = typeof user.token != 'undefined' && typeof user.access_token != 'undefined' && typeof user.id != 'undefined'&& typeof user.name != 'undefined' ? user : false;
            try {
                let theUrl = window.APP_DATA.apiUrl + 'verify';
                var xmlHttp = new XMLHttpRequest();
                xmlHttp.open( "POST", theUrl, false );
                xmlHttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                xmlHttp.setRequestHeader("x-access-token",user.access_token);
                xmlHttp.send();
                if(xmlHttp.status == 400){
                    throw 'Không thể kết nối server';
                }
                if(xmlHttp.status == 403 || xmlHttp.status == 401){
                    throw 'Không thể xác minh';
                }
                let res = JSON.parse(xmlHttp.responseText);
                if(typeof res.error == 'undefined' || typeof res.data == 'undefined' || typeof res.message == 'undefined'){
                    throw 'Không thể kết nối server';
                }
                if(res.error){
                    throw res.message;
                }

            } catch (error) {
                user = false;
            }
        }
        commit('SET_CURRENT_USER', user);
        return user;
    },
}
function saveState(key, state) {
    window.localStorage.setItem(key, JSON.stringify(state))
}
